import { render, staticRenderFns } from "./enterprisePerson.vue?vue&type=template&id=5cb5a218&scoped=true"
import script from "./enterprisePerson.vue?vue&type=script&lang=js"
export * from "./enterprisePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb5a218",
  null
  
)

export default component.exports